export default __webpack_public_path__ + "maps-examples-image-source-960-d91a21ba7f27cebb955f7c800cb7d4d6.webp";